<template>
  <li class="nav-item nav-item-language">
    <a @click.prevent="changeLanguage('en')" v-bind:class="locale === 'en' ? 'active-link' : ''" href>EN</a>
    <span>|</span>
    <a @click.prevent="changeLanguage('ru')" v-bind:class="locale === 'ru' ? 'active-link' : ''" href>RU</a>
  </li>
</template>

<script>
  export default {
    name: 'LanguageSelector',
    data: () => {
      return {
        locale: null
      }
    },
    created() {
      this.changeLanguage(localStorage.getItem('locale') || 'ru');
    },
    methods: {
      changeLanguage(lang) {
        import(`@/langs/${lang}.json`).then((messages) => {
          this.locale = lang;
          this.$i18n.setLocaleMessage(lang, messages);
          this.$moment.locale(lang);
          
          this.$i18n.locale = this.locale;

          localStorage.setItem('locale', lang);
        });
      }
    }
  }
</script>

<style scoped>

</style>
